import React from 'react';

import NewsletterPreview from '../../../components/Admin/Newsletter/NewsletterPreview.module';

function NewsletterPreviewView() {
  return <NewsletterPreview />;
}

export default NewsletterPreviewView; 